var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.name.indexOf('el-icon-') === 0)?_c('i',{class:_vm.name}):_c('svg',_vm._g({staticClass:"svg-icon",attrs:{"aria-hidden":"true"}},_vm.$listeners),[_c('use',{attrs:{"xlink:href":("#icon-" + _vm.name)}})])}
var staticRenderFns = []

export { render, staticRenderFns }